import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { withDeviceProvider } from '~/providers/DeviceProvider';
import { NETWORK_RETRY_SCHEDULE } from '~/utils/networkRetry/network-retry-schedule';
import styles from './ConnectivityGate.module.scss';
import { useConnectivity } from './hooks/useConnectivity';
export const GetConnectivityGateTID = (parentTestId)=>getTestIds(parentTestId);
const ActualConnectivityGate = (param)=>{
    let { testId, retrySchedule = NETWORK_RETRY_SCHEDULE } = param;
    const { ConnectivityGateTestIds } = useMemo(()=>GetConnectivityGateTID(testId), [
        testId
    ]);
    const announcement = useConnectivity({
        retrySchedule,
        toastTestId: ConnectivityGateTestIds.Toast()
    });
    const { browser } = useIoContext();
    const { t } = useLocaleKeys('common.connectivity');
    const announcements = {
        idle: '',
        lost: t.title(),
        restored: t.restored()
    };
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx(Box, {
        role: "status",
        className: styles.visuallyHidden,
        testId: ConnectivityGateTestIds.LiveRegion(),
        children: announcements[announcement]
    }), browser.getPortalRoot());
};
export const ConnectivityGate = withDeviceProvider(ActualConnectivityGate);
